module.exports = __webpack_public_path__ + "static/media/2-aperitivo-comp.2dacbdd1.jpg";